import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllDisputes } from '../../../api/transactions';

const useDisputes = (options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>) => {
  return useQuery({
    queryKey: ['disputes'],
    queryFn: getAllDisputes,
    ...options,
  });
};

export default useDisputes;
